import ScreenshotFab from './ScreenshotFab.vue';

export default {
  install(Vue) {
    Vue.component('ScreenshotFab', ScreenshotFab);
  },
};
